import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { setRegPage, currentWidget, setShowCustomPopup } from '../../../action/action'
import { getremoteAccessToken, getTVRemoteAuthToken } from '../../../action/tvChannelAction'
import TVLoginPage from './TVLoginPage'
import { setTVLoginPage } from '../../action/TVAction2'
import TVSelect from './TVSelect'
import TVRemote from './TVRemote'
import { tvWidgetColors } from '../../JS/colorConfig'
import { closeOrderPopUp } from '../../action/hCommerce2';
import {withTranslation} from "react-i18next";
import { CLICKED, EXIT } from '../../../config/constant'
import { sendAnalytics } from '../../../action/homeAction'
import { calculateTimeDifference, getDefaultAnalyticsLabel } from '../../JS/utility'
import Loader from '../../UI/loader'
import LoginRequiredOverlay from '../../UI/loginRequiredOverlay'
import { setGoHome, setLoginRequired } from '../../action/homeAction'

class TVcontrol extends Component {

    constructor(props) {
        super(props);
        this.state = {
            widgetLaunchTime: new Date,
            widgetName: this.props.currentWidgets.displayName,
            bearerTokenReceived: false,
            showLoader: false,
        }
    }
    


    callbackFromRemoteAccessapi = (status) => {
        console.log('status tv control', status)
        if(!status){
            this.props.closeOrderPopUp(true, this.props.t('room_control.tv_control.err-tv-offline'), "",true);
        }
    }

    componentDidMount() { 
        
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let room = localStorage.getItem("room");
        if (SessionToken && (!this.props.guestDetail.locationId || !this.props.guestDetail.guestToken)) {
            if (this.props.currentWidgets.widgetType && (!room || room === "null")) {
                if(process.env.REACT_APP_INROOMTAB == "true") {
                    this.props.setLoginRequired(true)
                } else {
                    this.props.setRegPage(true);
                }
                // this.props.setTVLoginPage(true);
                console.log("room", room);
                return;
            } else {
                console.log("there is some bug in guest registration flow.")
            }
        } else {
            if (!this.props.currentTv.remoteSessionToken) {
                this.setState({showLoader: true})
                if(process.env.REACT_APP_TV_REMOTE_JWT_FLOW_ENABLED == "true"){
                    this.props.getTVRemoteAuthToken((status) => {
                        if(status){
                            this.setState({bearerTokenReceived: true, showLoader: false})
                            this.props.getremoteAccessToken(this.props.roomRemoteDetails, this.callBackForColor, this.callbackFromRemoteAccessapi);
                        } else {
                            this.setState({error: true, errorMessage: "User not authorized to use TV remote", showLoader: false})
                            this.props.closeOrderPopUp(true, this.props.t("User not authorized to use TV remote"), "",true);
                        }
                    })
                } else {
                    this.setState({bearerTokenReceived: true, showLoader: false})
                    this.props.getremoteAccessToken(this.props.roomRemoteDetails, this.callBackForColor, this.callbackFromRemoteAccessapi);
                }
            } else {
                this.setState({bearerTokenReceived: true})
            }
            // if(this.props.roomRemoteDetails && this.props.roomRemoteDetails.length === 0){
            //     this.props.closeOrderPopUp(true, this.props.t('room_control.tv_control.err-tv-offline'), "",true);
            // }
        }
        // Send Analytics
        if(this.props.guestIsLoggedIn){
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.props.currentWidgets.displayName, 
                CLICKED, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget"}, 
                0, 
                this.props.guestIsLoggedIn
            );
        }
        //
        // tvWidgetColors(this.props.menuColor)
    }

    componentWillUnmount() {
        this.props.currentWidget({});
        // Send Analytics
        if(this.props.guestIsLoggedIn){
            let widgetCloseTime = new Date
            let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second');
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.state.widgetName, 
                EXIT, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration}, 
                0, 
                this.props.guestIsLoggedIn
            );
        }
        //
    }
    render() {
        return (
            <div>
                {
                    (this.props.roomRemoteDetails && this.props.roomRemoteDetails.length === 0) 
                    ? <TVRemote />
                    :  !this.props.currentTv.remoteSessionToken ? <TVSelect /> : <TVRemote />
                }
                { this.state.showLoader && <Loader /> }
            </div>
           
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        currentWidgets: state.store.sideNavBar.currentWidget,
        showTVLogin: state.store2.TVControl.showLogin,
        roomRemoteDetails: state.store.tvChannels.roomRemoteDetails,
        guestLoginPage: state.store.guestLoginPage,
        currentTv: state.store.tvChannels.currentTv,
        menuColor: state.store.home.MenuColor,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
    }
}
export default connect(
    mapStateToProps,
    {
        setRegPage,
        setTVLoginPage,
        currentWidget,
        getremoteAccessToken,
        closeOrderPopUp,
        sendAnalytics,
        getTVRemoteAuthToken,
        setGoHome,
        setLoginRequired,
        setShowCustomPopup
    }
)(withTranslation('translations')(TVcontrol));
